import React from "react";
import CardsLayout from "./Cards";

import AdapterLinkButton from "@/components/Adapter/LinkButton";
import Banner from "./Banner";
import CredSection from "../../UI/CredSection";

export default function CredHowTo() {
  return (
    <CredSection className="space-y-4 md:space-y-8">
      <CardsLayout />
      <Banner
        title="DEPOSIT MORE, GET MORE."
        description="EXPLORE VAULTS & DEPOSIT NOW TO START EARNING CRED."
        isLoading={false}
        actionItem={<AdapterLinkButton href="/">Explore Vaults</AdapterLinkButton>}
      />
    </CredSection>
  );
}
